import { render, staticRenderFns } from "./InstructorsTable.vue?vue&type=template&id=6ce7dce8&"
import script from "./InstructorsTable.vue?vue&type=script&lang=ts&"
export * from "./InstructorsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports